import React from 'react'
import ModalFormUI from '../../../widgets/form/ModalFormUI'
import InputTextSF from '../../../widgets/form/InputTextSF'
import InputReadOnlyUI from '../../../widgets/form/InputReadOnlyUI'

const BankAccountAddModalUI = ({ context, successMsg, errorList, setErrorList,
    // modes
    submitted, addBankAccountMode,
    // event handlers
    onSubmit, onCancelClick,
    //
    bankAccountNumber, onbankAccountNumberChange, bankAccountNumberError, setbankAccountNumberError,
    ifscCode, onifscCodeChange, ifscCodeError, setifscCodeError
}) =>
    <ModalFormUI
        context={context}
        titleLabel='Add Bank Account'
        buttonLabel='Add'
        cancelLabel='Cancel'
        isOpen={addBankAccountMode}
        onRequestClose={onCancelClick}
        successMsg={successMsg}
        errorList={errorList}
        setErrorList={setErrorList}
        onSubmit={onSubmit}
        busy={submitted}
    >
        <InputTextSF type='text' name='bankAccountNumber' label='Bank Account Number'
            required={true} maxLength={100} autoFocus={true}
            value={bankAccountNumber} onChange={onbankAccountNumberChange}
            error={bankAccountNumberError} setError={setbankAccountNumberError}
        />
        <InputTextSF type='text' name='ifscCode' label='IFSC Code'
            required={true}
            value={ifscCode} onChange={onifscCodeChange}
            error={ifscCodeError} setError={setifscCodeError}
        />
    </ModalFormUI>

export default BankAccountAddModalUI
